export default "__VITE_ASSET__875643d2__"